import { createContext, useContext, useState, useRef, useEffect } from "react"
import { login } from "../services/AuthService"
import { useNavigate } from "react-router-dom"
import { notifyInvalidCredentials, notifyUserLoggedIn } from "./notifications"

const AuthContext = createContext()

export const AuthProvider = ({children}) => {
    const navigate = useNavigate()
    const [loadingSuccess, setLoadingSuccess]= useState(false)
    const [message, setMessage] = useState("")
    
    const timeoutRef = useRef();


    const loginAction = async (data) => {
        setLoadingSuccess(true)
        try {
            const response = await login(data)
            
            if (response && response.status === 200) {
                const resData = response.data.data 
                const accessToken = resData.accessToken
                localStorage.setItem("site", accessToken)
                setMessage("Login success")
                notifyUserLoggedIn()   
                navigate("/dashboard/products")
            } else {
                setMessage("Invalid response from server")
            }
        } catch (err) {
            console.error('Login error:', err)
            setMessage("Invalid credentials")
            if (err && err.response && err.response.status === 401) {
                notifyInvalidCredentials()
            }
        } finally {
            setLoadingSuccess(false)
        }
   }

   useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);


   return <AuthContext.Provider value={{loginAction, loadingSuccess, message}}>
    {children}
   </AuthContext.Provider>
}

export default AuthProvider

export const useAuth = () => {
    return useContext(AuthContext)
}

